export interface IntroLesson {
    courseId: number;
    topicId: number;
    lessonId: number;
    title?: string;
}

export const DEFAULT_INTRO_LESSONS: IntroLesson[] = [{ courseId: 31, topicId: 72, lessonId: 383 }];
